import axios from "axios";
export default {
  namespaced: true,
  state() {
    return {
      accountInfo: {
        userName: { label: "User Name", value: "JohnSnow" },
        emailAddress: { label: "Email address", value: "johnsnow123@gmail.com", status: "verified", type: "button", btn: "edit" },
        password: { label: "Password", value: "pass.188", type: "button", btn: "change" }
      },
      personalInfo: {
        firstName: { label: "First Name", value: "" },
        lastName: { label: "Last Name", value: "" },
        gender: { label: "Gender", value: "" },
        dateOfBirth: { label: "Date of birth", value: "" },
        countryOfBirth: { label: "Country of birth", info: { code: 'cn', name: 'China' } },
        nationality: { label: "Nationality", info: { code: 'cn', name: 'China' } }
      },
      locationInfo: {
        countryCurrency: { label: "Country / Currency", value: "China / RMB" },
        cityProvince: { label: "City / Province", value: "" },
        postalCode: { label: "Postal code", value: "" },
        timeZone: { label: "Timezone", info: { code: 'cn', name: 'China', gmt: '+8' } },
        address1: { label: "Primary address", value: "" },
        address2: { label: "Secondary address", value: "" }
      },
      contactInfo: {
        mobile: { label: "Mobile", value: { areaCode: '82', number: '' } }
      },
      profileVerification: [
        { require: "Proof of Identity, Local bank transfer, Skill", status: "Required" },
        { require: "Proof of address, Invopay", status: "Required" }
      ],
      balanceInfo: {
        currency: { label: "RMB" },
        balance: { label: "balance", amount: Intl.NumberFormat("en-US").format(123456.78) },
        eligibleWithdrawal: { label: "Eligible Withdrawal", value: Intl.NumberFormat("en-US").format(54321.21) },
        remainingRollover: { label: "Remaining Rollover", value: Intl.NumberFormat("en-US").format(1188.88) }
      },
      preferredLanguage: 'en',
    }
  },
  getters: {
    accountInfo(state) {
      return state.accountInfo
    },
    personalInfo(state) {
      return state.personalInfo
    },
    locationInfo(state) {
      return state.locationInfo
    },
    contactInfo(state) {
      return state.contactInfo
    },
    profileVerification(state) {
      return state.profileVerification
    },
    balanceInfo(state) {
      return state.balanceInfo
    },
    preferredLanguage(state) {
      return state.preferredLanguage
    },
  },

  mutations: {
    accountChange(state, payload) {
      state.accountInfo.emailAddress.value = payload.user.emailAddress
    },

    passwordChange(state, payload) {
      state.accountInfo.password.value = payload.user.newPassword
    },

    personalChange(state, payload) {
      state.personalInfo.firstName.value = payload.user.firstName
      state.personalInfo.lastName.value = payload.user.lastName
      state.personalInfo.gender.value = payload.user.gender
      state.personalInfo.dateOfBirth.value = payload.user.dateOfBirth
      // state.personalInfo.countryOfBirth.value = payload.user.countryOfBirth
      // state.personalInfo.nationality.value = payload.user.nationality
    },

    locationChange(state, payload) {
      // state.locationInfo.countryCurrency.value = payload.user.countryCurrency.name
      state.locationInfo.cityProvince.value = payload.user.cityProvince
      state.locationInfo.postalCode.value = payload.user.postalCode
      state.locationInfo.timeZone.info = payload.user.timeZone

      const code = payload.user.timeZone.code
      state.locationInfo.timeZone.info.gmt = (() => {
        return code === 'br' ? '-3'
          : code === 'kh' || code === 'id' || code === 'th' || code === 'vn' ? '+7'
            : code === 'cn' || code === 'my' ? '+8'
              : code === 'jp' || code === 'kr' ? '+9'
                : code === 'uk' ? '+0'
                  : '--'
      })()

      state.locationInfo.address1.value = payload.user.address1
      state.locationInfo.address2.value = payload.user.address2
    },

    contactChange(state, payload) {
      state.contactInfo.mobile.value = payload
    },
    fetchPreferredLanguage(state, payload){
      state.preferredLanguage = payload
    },
  },

  actions: {
    accountChange({ commit }, payload) {
      commit("accountChange", payload)
    },

    passwordChange({ commit }, payload) {
      commit("passwordChange", payload)
    },

    personalChange({ commit }, payload) {
      commit("personalChange", payload)
    },

    locationChange({ commit }, payload) {
      commit("locationChange", payload)
    },

    contactChange({ commit }, payload) {
      commit("contactChange", payload)
    },

    async fetchPreferredLanguage({ commit }) {
      await axios.get('https://qol-myaccount-default-rtdb.firebaseio.com/user.json')
        .then(res => (() => {
          commit('fetchPreferredLanguage',res.data.preferredLanguage)
        })())
        .catch(error => alert(error.message))
    },
    async updatePreferredLanguage(context, language){
      // console.log(language)
      const lang = (() => {
        return language === 'English' ? 'en' : 'zh'
      })()
      await axios.put('https://qol-myaccount-default-rtdb.firebaseio.com/user.json', {preferredLanguage: lang})
                .then(() => {
                    context.dispatch('fetchPreferredLanguage')
                })
                .catch(error => alert(error.message))
    },
  }
}
